type TagProps = {
  value: React.ReactNode;
  textColor?: string;
  tagColor?: string | null;
};

const Tag = ({ value, textColor, tagColor }: TagProps) => (
  <span style={{ color: textColor, backgroundColor: tagColor ?? undefined, padding: '2px 8px', borderRadius: 4 }}>
    {value}
  </span>
);

export default Tag;
